module.exports = __webpack_public_path__ + "static/img/necklace.c53f36c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/necklace.png
// module id = syBy
// module chunks = 0